import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.special || initialState;

const makeSelectSpecialFilterMenuStatus = (state) => {
  return createSelector(selectGlobal, (specialState) => specialState.specialFilterMenuStatus);
}

export { makeSelectSpecialFilterMenuStatus };
